import Api from "./Api";
import Api_2 from "./Api_extra";
import { createQueryString } from "./ApiHelper";

export default {
  getBinNumbers(payload) {
    return Api().post(`/api/marketing/viewBinNumbers`, payload);
  },

  addBinNumbers(payload) {
    return Api().post("/api/marketing/addbinnumbers", payload);
  },
  viewBinNumbers(payload) {
    if (payload && payload.hasOwnProperty("searchValue")) {
      return Api().post(
        `/api/marketing/getbinNumbers?searchValue=${payload.searchValue}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`,
        payload
      );
    } else {
      return Api().post("/api/marketing/getbinNumbers", payload);
    }
  },
  editBinNumbers(payload) {
    return Api().put("/api/marketing/editbinnumbers", payload);
  },

  // BANK API'S
  getAllBank(
    perPage,
    currentPage,
    columnName,
    orderBy,
    searchValue,
    filterIsActive
  ) {
    return Api().get(
      `/api/marketing/bank?perPage=${perPage}&currentPage=${currentPage}&columnName=${columnName}&orderBy=${orderBy}&searchValue=${searchValue}&filter_is_active=${filterIsActive}`
    );
  },
  getBankDetails(payload) {
    return Api().get(`/api/marketing/bank/${payload.bank_id}`);
  },
  addBank(payload) {
    return Api().post("/api/marketing/addBank", payload);
  },
  editBank(payload) {
    return Api().put(`/api/marketing/updatebank/${payload.bank_id}`, payload);
  },

  //INSTITUTE API'S

  addInstitution(payload) {
    return Api().post(`/api/marketing/addinstitution`, payload);
  },
  getAllInstitutes(
    perPage,
    currentPage,
    columnName,
    orderby,
    searchValue,
    filterIsActive
  ) {
    return Api().get(
      `/api/marketing/viewinstitution?limit=${perPage}&currentPage=${currentPage}&columnName=${columnName}&orderBy=${orderby}&searchValue=${searchValue}&filter_is_active=${filterIsActive}`
    );
  },
  getInstitutionDetails(payload) {
    return Api().get(
      `/api/marketing/viewinstitutedetail/${payload.institution_id}`
    );
  },
  editInstitution(payload) {
    return Api().put(
      `/api/marketing/updateinstitution/${payload.institution_id}`,
      payload
    );
  },

  //OFFER TYPE API'S

  getAllOfferType(perPage, currentPage, columnName, orderby, filterIsActive) {
    return Api().get(
      `/api/marketing/viewoffertype?limit=${perPage}&currentPage=${currentPage}&columnName=${columnName}&orderBy=${orderby}&filter_is_active=${filterIsActive}`
    );
  },
  addOfferType(payload) {
    return Api().post("/api/marketing/addoffertype", payload);
  },
  getSingleOfferDetails(payload) {
    return Api().get(`/api/marketing/viewofferdetail/${payload.ot_id}`);
  },
  editOfferType(payload) {
    return Api().put(
      `/api/marketing/updateoffertype/${payload.ot_id}`,
      payload
    );
  },

  //CARD TYPE API'S

  addCardType(payload) {
    return Api().post("/api/marketing/addcardtype", payload);
  },
  getAllCardType(
    perPage,
    currentPage,
    bank_id,
    columnName,
    orderBy,
    filterIsActive
  ) {
    return Api().get(
      `/api/marketing/viewcardtype?limit=${perPage}&currentPage=${currentPage}&bank_id=${bank_id}&columnName=${columnName}&orderBy=${orderBy}&filter_is_active=${filterIsActive}`
    );
  },
  getSingleCardDetails(payload) {
    return Api().get(`/api/marketing/viewcarddetail/${payload.card_id}`);
  },
  editCardType(payload) {
    return Api().put(
      `/api/marketing/updatecardtype/${payload.card_id}`,
      payload
    );
  },

  // CUSTOMERS API

  addCustomer(payload) {
    return Api().post("/api/marketing/addcustomer", payload);
  },
  getAllCustomers(
    perPage,
    currentPage,
    columnName,
    orderBy,
    searchValue,
    filterIsActive
  ) {
    return Api().get(
      `/api/marketing/viewcustomers?limit=${perPage}&currentPage=${currentPage}&columnName=${columnName}&orderBy=${orderBy}&searchValue=${searchValue}&filter_is_active=${filterIsActive}`
    );
  },
  getAllGuestCustomer(
    perPage,
    currentPage,
    columnName,
    orderBy,
    searchValue,
    filterIsActive
  ) {
    return Api().get(
      `/api/marketing/view-guest-customers?limit=${perPage}&currentPage=${currentPage}&columnName=${columnName}&orderBy=${orderBy}&searchValue=${searchValue}&filter_is_active=${filterIsActive}`
    );
  },
  getAllCustomerGuestList(
    perPage,
    currentPage,
    columnName,
    orderBy,
    searchValue,
    filterIsActive,
    user_type = "",
    transaction_type = "",
    fromDate,
    toDate
  ) {
    return Api().get(
      `/api/marketing/view-all-customers-guest?limit=${perPage}&currentPage=${currentPage}&columnName=${columnName}&orderBy=${orderBy}&searchValue=${searchValue}&filter_is_active=${filterIsActive}&user_type=${user_type}&transaction_type=${transaction_type}&fromDate=${fromDate}&toDate=${toDate}`
    );
  },
  getAllCustomerGuestListExcel(
    perPage,
    currentPage,
    columnName,
    orderBy,
    searchValue,
    filterIsActive,
    user_type = "",
    transaction_type = ""
  ) {
    return Api().get(
      `/api/marketing/view-guest-customers-excel?limit=${perPage}&currentPage=${currentPage}&columnName=${columnName}&orderBy=${orderBy}&searchValue=${searchValue}&filter_is_active=${filterIsActive}&user_type=${user_type}&transaction_type=${transaction_type}`
    );
  },
  getAllCustomerGuestListExcelNew(payload) {
    return Api().get(`/api/marketing/view-guest-customers-excel/${payload}`);
  },
  viewAllCustomerVerification(
    perPage,
    currentPage,
    columnName,
    orderBy,
    searchValue,
    filterIsActive
  ) {
    return Api().get(
      `/api/marketing/view-all-customer-verification?limit=${perPage}&currentPage=${currentPage}&columnName=${columnName}&orderBy=${orderBy}&searchValue=${searchValue}&filter_is_active=${filterIsActive}`
    );
  },
  getSingleCustomerDetails(payload) {
    return Api().get(`/api/marketing/viewcustomerdetail/${payload.cust_id}`);
  },
  editCustomer(payload) {
    return Api().put(
      `/api/marketing/updatecustomer/${payload.cust_id}`,
      payload
    );
  },

  /**
   * ADD PERMOTIONS OFFERS AND VOUCHERS START
   */
  GetAllFNBItems() {
    return Api().get(`/api/marketing/getallfnbitems`);
  },

  GETUSERLIST() {
    return Api().get(`/api/marketing/getUsersList`);
  },

  GetCustomerCategories() {
    return new Promise((resolve) => {
      return resolve({
        data: {
          status: true,
          message: "Records Successfully Fetched",
          Records: [
            {
              buc_id: 1,
              buc_category_name: "Senior Citizen",
              buc_is_active: "Y",
              created_by: 1,
              created_at: "2019-09-11T12:30:00.000Z",
              updated_by: 1,
              updated_at: "2019-09-11T12:30:00.000Z",
            },
            {
              buc_id: 2,
              buc_category_name: "Student",
              buc_is_active: "Y",
              created_by: null,
              created_at: null,
              updated_by: null,
              updated_at: null,
            },
            {
              buc_id: 3,
              buc_category_name: "Armed",
              buc_is_active: "Y",
              created_by: null,
              created_at: null,
              updated_by: 1,
              updated_at: "2019-11-08T06:00:00.000Z",
            },
          ],
        },
      });
    });

    // return Api().get("/api/marketing/customeroffercategories");
  },
  GetActiveInstitites() {
    return Api().get("/api/marketing/viewactiveinstitution");
  },
  GetOfferUsage(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/marketing/viewofferusage/${payload.os_id}${query}`);
  },
  GetVoucherUsage(payload) {
    const query = createQueryString(payload);
    return Api().get(
      `/api/marketing/viewvoucherusage/${payload.voucher_id}${query}`
    );
  },

  GetAllVoucherListCSV(payload) {
    return Api().get(
      `/api/marketing/export-all-voucher?voucher_title=${payload.voucher_title}&exportType=${payload.exportType}`
    );
  },
  GetSingleVoucherListCSV(payload) {
    return Api().get(
      `/api/marketing/export-voucher?voucher_title=${payload.voucher_title}&exportType=${payload.exportType}`
    );
  },
  GetActiveBanks() {
    return Api().get("/api/marketing/viewactivebank");
  },
  GetActiveBanksCards(bank_id) {
    return Api().get(`/api/marketing/viewactivebankcard?bank_id=${bank_id}`);
  },
  GetVoucherPartners() {
    return Api().get(`/api/marketing/activevoucherpartners`);
  },
  AddVochers(payload) {
    return Api().post(`/api/marketing/addvouchers`, payload);
  },
  GetVouchers(payload) {
    let status =
      payload && payload.hasOwnProperty("status") ? payload.status : null;
    return Api().get(
      `/api/marketing/getactivevoucher?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&searchValue=${payload.searchValue}&status=${status}`
    );
  },
  GetVouchersCodes(payload) {
    const query = createQueryString(payload);
    return Api().post(`/api/marketing/getactivevoucher${query}`, payload);
  },
  GetSingleVoucher(payload) {
    let isEdit =
      payload && payload.hasOwnProperty("isEdit") ? payload.isEdit : null;
    return Api().get(
      `/api/marketing/getactivevoucher/${payload.voucher_id}?isEdit=${isEdit}`
    );
  },
  UpdateVoucher(payload) {
    return Api().put(
      `/api/marketing/updatesinglevoucher/${payload.voucherid}`,
      payload
    );
  },
  GetPromotionAndOffers(payload) {
    // Not DONE
    // return Api().get(`/api/marketing/getactivevoucher?limit=${payload.limit}&currentPage=${payload.currentPage}`);
  },
  AddPromotionAndOffers(payload) {
    return Api().post(`/api/marketing/addpromotionsandoffers`, payload);
  },
  UpdatePromotionAndOffers(payload) {
    return Api().put(
      `/api/marketing/updatepromotionsandoffers/${payload.os_id}`,
      payload
    );
  },
  GetPrmotionAndoffers(payload) {
    let status =
      payload && payload.hasOwnProperty("status") ? payload.status : null;
    return Api().get(
      `/api/marketing/getactivepromotionsandoffers?limit=${
        payload.limit
      }&currentPage=${payload.currentPage}&columnName=${
        payload.columnName
      }&orderBy=${payload.orderBy}&searchValue=${
        payload.searchValue
      }&offerGroupType=${
        payload.offer_group_type_id
      }&status=${status}&time=${Date.now()} &type=${payload.type}`
    );
  },
  GetSinglePermotiosAndOffers(payload) {
    let isEdit =
      payload && payload.hasOwnProperty("isEdit") ? payload.isEdit : null;
    return Api().get(
      `/api/marketing/getactivepromotionsandoffers/${
        payload.offertypeid
      }?isEdit=${isEdit}&time=${Date.now()}`
    );
  },
  GetVerificationList() {
    return Api().get(`/api/marketing/getverificationdocs`);
  },
  /**
   * ADD PERMOTIONS OFFERS AND VOUCHERS END
   */
  /**
   * POS OFFERS START
   */
  GetOffersCollections(payload) {
    return Api().post(`/api/posadmin/getofferscollection`, payload);
  },
  GetOffersVoucherCollections(payload) {
    return Api().post(`/api/posadmin/getoffersvouchercollection`, payload);
  },
  GetFnbOffersCollections(payload) {
    return Api().post(`/api/posadmin/getfnbofferscollection`, payload);
  },
  GetFnbOffersVoucherCollections(payload) {
    return Api().post(`/api/posadmin/getfnbvouchercollection`, payload);
  },
  /**
   * POS OFFERS END
   */

  //Global Loaylty Settings Start
  GetActiveGlobalLoyaltySettings(payload) {
    return Api().post("/active-list/loyalty_settings", payload);
  },

  //Global Loyalty Settings Start
  AddGlobalLoyaltySettings(payload) {
    return Api().post(`/api/marketing/globalloyaltysettings`, payload);
  },
  GetGlobalLoyaltySettings(payload) {
    return Api().get(
      `/api/marketing/globalloyaltysettings?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&filter_is_active=${payload.filter_is_active}`
    );
  },
  GetGlobalLoyaltySettingsBYID(payload) {
    return Api().get(`/api/marketing/globalloyaltysettings/${payload.ls_id}`);
  },
  UpdateGlobalLoyaltySettingsBYID(payload) {
    return Api().put(`/api/marketing/globalloyaltysettings`, payload);
  },
  //Global Loyalty Settings End

  //Cinema Loyalty Settings Start
  AddCinemaLoyaltySettings(payload) {
    return Api().post(`/api/marketing/cinemaloyaltysettings`, payload);
  },
  getcinemaloyaltysettingsList(payload) {
    return Api().get(
      `/api/marketing/cinemaloyaltysettings?limit=${payload.limit}&currentPage=${payload.currentPage}&cinema_id=${payload.cinema_id}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&searchValue=${payload.searchValue}&filter_is_active=${payload.filter_is_active}`
    );
  },
  GetCinemaLoyaltySettingsBYID(payload) {
    return Api().get(`/api/marketing/cinemaloyaltysettings/${payload.cls_id}`);
  },
  UpdateCinemaLoyaltySettingsBYID(payload) {
    return Api().put(`/api/marketing/cinemaloyaltysettings`, payload);
  },
  //Cinema Loyalty Settings End

  //Customer Loyalty Points START
  GetCustomerLoyaltyPoints(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/marketing/customerloyaltypoints${query}`);
  },
  GetCustomerLoyaltyPointsBYID(payload) {
    return Api().get(
      `/api/marketing/customerloyaltypoints/${payload.clp_id}?limit=${payload.limit}&currentPage=${payload.currentPage}&type=${payload.type}`
    );
  },
  updateLoyalityPoints(payload) {
    return Api().post(`/api/marketing/updateLoyalityPoints`, payload);
  },

  //SEO
  AddPage(payload) {
    return Api().post("/api/marketing/pages", payload);
  },
  GetPageList(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/marketing/pages/${query}`);
  },
  GetPage(payload) {
    console.log("payload :>> ", payload);
    return Api().get(`/api/marketing/pages?page_id=${payload.seo_id}`);
  },
  EditPage(payload) {
    return Api().put("/api/marketing/pages", payload);
  },
  GetPageContent(payload) {
    return Api().get(`/api/marketing/page?page_id=${payload.page_id}`);
  },

  //Cash Cards
  AddCashCard(payload) {
    return Api().post("/api/marketing/cashcard", payload);
  },
  GetCashCardList(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/marketing/getcashcardlist/${query}`);
  },
  GetCashCard(payload) {
    return Api().get(
      `/api/marketing/cashcard?cash_card_id=${payload.cash_card_id}`
    );
  },
  EditCashCard(payload) {
    return Api().put("/api/marketing/cashcard", payload);
  },
  UpdateCashCardAmount(payload) {
    return Api().put("/api/marketing/updatecashcardamount", payload);
  },
  GetCashCardLogs({ cash_card_id, ...payload }) {
    const query = createQueryString(payload);
    return Api().get(`/api/marketing/getcashcardlogs/${cash_card_id}/${query}`);
  },
  /*
    Offer Voucher Logs
    */
  AddOfferVoucherLogs(payload) {
    return Api().post(`/api/marketing/offer_voucher_logs`, payload);
  },
  AddOfferVoucherLogsV2(payload) {
    return Api().post(`/api/marketing/v2/verifyPromotion`, payload);
  },
  GetAllOfferVoucherLogs() {
    return Api().get(`/api/marketing/offer_voucher_logs`);
  },
  VerifyVoucherCode(payload) {
    return Api().post(`/api/marketing/verifyvouchercode`, payload);
  },
  VerifyVoucherCodeV2(payload) {
    return Api().post(`/api/marketing/v2/verifyvouchercode`, payload);
  },
  GetCashCardIdentifier() {
    return Api().get(`/api/marketing/getCashCardIdentifier`);
  },
  GetSingleCashCardTemplate(payload) {
    return Api().get(
      `/api/get-website-cashcard-detail/${payload.w_cash_card_unique_id}`
    );
  },
  AddCashCardTemplate(payload) {
    return Api().post(`/api/add-website-cash-card`, payload);
  },
  GetWebsiteCashCards(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/get-website-cash-card${query}`);
  },
  GetCashCardTransactionsCount(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/get-cash-card-transaction-count`, {
      params: payload,
    });
  },
  GetCashCardTransactions(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/get-cash-card-transaction${query}`);
  },
  UpdateCardStatus(payload) {
    return Api().post(`/api/update_cash_card_status`, payload);
  },
  UploadCustomerLoyality(payload) {
    return Api().post(`/api/marketing/upload-customer-loyality`, payload);
  },
  getCinemaScreenSeats(payload) {
    return Api().post(`/api/get-cinema-wise-screens-seats`, payload);
  },
  addVouchersV2(payload) {
    return Api().post(`/api/add-voucher-v2`, payload);
  },
  getVouchersV2(payload) {
    return Api().get(`/api/get-voucher-v2/${payload.voucher_id}`);
  },
  editVouchersV2(payload) {
    return Api().put(`/api/edit-voucher-v2`, payload);
  },
  getVoucherUseage(payload) {
    return Api().post("/api/get-voucher-useage-v2", payload);
  },
  getSingleActiveVoucherCodes(payload) {
    return Api().post(`/api/active-voucher-codes-v2`, payload);
  },
  AddMoviePass(payload) {
    return Api().post(`/api/admin/add_movie_pass`, payload);
  },
  GetAllMoviePassList(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/admin/ms_movie_passes${query}`);
  },
  GetMoviePassDetailsById(payload) {
    return Api().get(`/api/admin/ms_movie_passes/${payload.pass_id}`);
  },
  GetAllMoviePassSales(payload) {
    return Api().post(`/api/movie-pass/get-all-sales`, payload);
  },
  AddEditOfferGroupType(payload) {
    return Api().post("/api/marketing/ms-offer-group-type", payload);
  },
  GetAllOfferGroupType(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/marketing/get-offer-group-type${query}`);
  },
  UpdateOfferGroupTypeOrder(payload) {
    return Api().post("/api/marketing/offer-group-type-order", payload);
  },
  migrateCustomersTestDONOTRUN(payload) {
    return Api().post(`/api/migrate/migrate-customer`, payload);
  },
  getAllCustomerGuestListV2(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/marketing/view-all-customers-guest-v2${query}`);
  },
  addOfferVoucherNew(payload) {
    return Api().post(`/api/marketing/add-offer-voucher`, payload);
  },
  getSingleOfferVouchers(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/marketing/get-single-offer-voucher${query}`);
  },
  editOfferVoucherNew(payload) {
    return Api().put(`/api/marketing/edit-offer-voucher`, payload);
  },
  getVoucherCodesList(payload) {
    return Api().post(`/api/new-active-voucher-codes-v2`, payload);
  },
  getCinemaList(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/marketing/getCinemaList${query}`, payload);
  },
  getCinemawiseScreenList(payload) {
    let query = createQueryString(payload);
    return Api().get(
      `/api/marketing/gettCinemawiseScreenList${query}`,
      payload
    );
  },
  getOffersForBanners(payload) {
    return Api().get(`/api/marketing/getOffersForBanners`, payload);
  },
  addVouchersMerch(payload) {
    return Api().post(`/api/admin/add/merchandise-voucher`, payload);
  },
  GetVouchersMerchandise(payload) {
    let status =
      payload && payload.hasOwnProperty("status") ? payload.status : null;
    return Api().get(
      `api/admin/merchandise-vouchers-list?limit=${payload.limit}&currentPage=${payload.currentPage}&searchValue=${payload.searchValue}`
    );
  },
  editVouchersMerch(payload) {
    return Api().put(`/api/admin/update/merchandise-voucher`, payload);
  },
  getVouchersMerch(payload) {
    return Api().put(
      `/api/admin/get/merchandise-voucher/${payload.m_voucher_id}`
    );
  },
  getFnbItemsForFnbDiscountsOfferType(payload) {
    return Api().get(`/api/marketing/getFnbItemsForFnbDiscountsOfferType`);
  },
  searchUsersList(payload) {
    return Api().get(`/api/marketing/searchUsersList?searchValue=${payload.searchValue}`);
  },
  AddCourtseyGroups(payload) {
      return Api().post(`/api/admin/add/courtsey_group`, payload);
    },
  UpdateCourtseyGroups(payload) {
    return Api().post(`/api/admin/update/courtsey_group`, payload);
  },
  GetAllCourtseyGroups(payload) {
    return Api().post(`/api/admin/get/courtsey_group`, payload);
  },
  GetSingleCourtseyGroup(payload) {
    return Api().get(`/api/admin/get/courtsey_group/${payload.cg_id}`);
  },
  AddCourtseyUsers(payload) {
    return Api().post(`/api/admin/add/courtsey_users`, payload);
  },
  UpdateCourtseyUsers(payload) {
    return Api().post(`/api/admin/update/courtsey_users`, payload);
  },
  GetAllCourtseyUsers(payload) {
    return Api().post(`/api/admin/get/courtsey_users`, payload);
  },
  GetSingleCourtseyUser(payload) {
    return Api().get(`/api/admin/get/courtsey_users/${payload.cu_id}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/MarketingService.js